import { BASE_URL_API } from "../../../References/URLs";
// Adjust the import path above to wherever BASE_URL_API actually lives
// in the project — kept relative here since the real location wasn't
// shown.

// Centralizes the exact pattern from getInventoryProducts: POST, token
// folded into the body alongside the resource-specific payload,
// response.ok checked first, then respo.status, then tokenExpired
// handled via authCtx.logout(). Every screen calls this instead of
// repeating the fetch/try/catch boilerplate at each of the 17 call sites.
export const callComConfigApi = async (resource, payload, authCtx) => {
    try {
        const response = await fetch(BASE_URL_API + resource, {
            method: "POST",
            body: JSON.stringify({
                token: authCtx?.token,
                ...payload,
            }),
        });

        if (!response.ok) {
            return { status: "failed", message: "network error", response: null };
        }

        const respo = await response.json();

        if (respo?.status !== "success" && respo?.message === "tokenExpired") {
            authCtx?.logout();
        }

        return respo;
    } catch (error) {
        console.log("comConfig API error [" + resource + "]", error);
        return { status: "failed", message: "request failed", response: null };
    }
};